import React from "react";
import LeadAcceptanceConfigContent from "../components/lead-acceptance/lead-acceptance-config-content";

const LeadAcceptanceConfig = () => {
  return <LeadAcceptanceConfigContent />;
};

export default LeadAcceptanceConfig;
